import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import { ethers } from "ethers";
import { getProviderOrSigner } from "../utils";
import { useAuthContext } from "./AuthContextProvider";

const Web3Context = createContext();

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      infuraId: process.env.REACT_APP_INFURA_ID,
    },
    chainId: 4,
  },
};
const web3Modal = new Web3Modal({
  network: process.env.REACT_APP_INFURA_NETWORK,
  cacheProvider: true,
  providerOptions,
});

export const UseWeb3Context = ({ children }) => {
  const [library, setMultiLibrary] = useState();
  const [account, setMultiAccount] = useState();
  const {
    setAuthLibrary,

    setAuthAccount,
  } = useAuthContext();

  const mulitpleWallet = async () => {
    try {
      const provider = await web3Modal.connect();
      const library = new ethers.providers.Web3Provider(provider);
      const accounts = await library.listAccounts();
      // setAuthLibrary(library);
      setMultiLibrary(library);
      setAuthLibrary(library);
      if (accounts) {
        // setAuthAccount(accounts[0]);
        setMultiAccount(accounts[0]);
        setAuthAccount(accounts[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    try {
      if (localStorage.getItem("auth-token")) {
        mulitpleWallet();
      }
    } catch (err) {
      console.log();
    }
  }, []);

  return (
    <Web3Context.Provider
      value={{
        library,
        setMultiLibrary,
        account,
        setMultiAccount,
      }}
    >
      {children}
    </Web3Context.Provider>
  );
};

export const useWeb3Context = () => {
  const context = useContext(Web3Context);
  if (context === undefined) {
    throw new Error("useAuthContext must be used within a AuthContextProvider");
  }
  return context;
};
